<div class="page-container">

  <!-- Header -->
  <div class="page-header">
    <div class="page-title-section">
      <mat-icon class="page-icon">public</mat-icon>
      <div class="page-title">Holidays</div>
    </div>

    <div class="header-actions">
      <!-- Year filter -->
      <mat-form-field appearance="outline" class="year-select">
        <mat-select
          [(ngModel)]="selectedYear"
          (ngModelChange)="onYearChange()"
          aria-label="Filter by year"
        >
          <mat-option *ngFor="let year of years" [value]="year">{{ year }}</mat-option>
        </mat-select>
      </mat-form-field>

      <!-- Add button -->
      <button
        mat-stroked-button
        color="primary"
        class="add-btn"
        (click)="onAddHoliday()"
        aria-label="Add holiday"
      >
        <mat-icon>add</mat-icon>
        ADD HOLIDAY
      </button>
    </div>
  </div>

  <!-- Table -->
  <div class="mat-elevation-z2 table-card">
    <table mat-table [dataSource]="dataSource" matSort aria-label="Holidays list">

      <!-- Holiday name -->
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Holiday name</th>
        <td mat-cell *matCellDef="let row">{{ row.name }}</td>
      </ng-container>

      <!-- Date of holiday -->
      <ng-container matColumnDef="date">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Date of holiday</th>
        <td mat-cell *matCellDef="let row">{{ row.dateDisplay }}</td>
      </ng-container>

      <!-- Day of week -->
      <ng-container matColumnDef="dayOfWeek">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Day of week</th>
        <td mat-cell *matCellDef="let row">{{ row.dayOfWeekDisplay }}</td>
      </ng-container>

      <!-- Actions -->
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef class="actions-header">Action</th>
        <td mat-cell *matCellDef="let row" class="actions-cell">
          <button
            mat-icon-button
            class="action-btn edit-btn"
            (click)="onEdit(row); $event.stopPropagation()"
            [attr.aria-label]="'Edit ' + row.name"
          >
            <mat-icon>edit</mat-icon>
          </button>
          <button
            mat-icon-button
            class="action-btn delete-btn"
            (click)="onDelete(row); $event.stopPropagation()"
            [attr.aria-label]="'Delete ' + row.name"
          >
            <mat-icon>delete_outline</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="table-row"></tr>
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell no-data-cell" [attr.colspan]="displayedColumns.length">
          No holidays found for {{ selectedYear }}.
        </td>
      </tr>
    </table>
  </div>

  <!-- Footer -->
  <div class="footer-actions">
    <button mat-stroked-button class="go-back-btn" (click)="goBack()" aria-label="Go back">
      GO BACK
    </button>
  </div>

</div>
